var SINGLE_WORD_PROPERTIES = [
    'bg',
    'text',
    'border',
    'ring' ];

var Animator = function Animator(el, options, trigger, action) {
    this.el = el;
    this.options = options;
    this.action = action;
    this.trigger = trigger;
    this.index = 0;
    this.timeline = [];
    this.runTimer = {};
    this.rollbackTimer = {};
    this.durations = [];
};

Animator.prototype.setup = function setup () {
        var this$1 = this;

    this.registerListeners();
    this.buildTimeline();

    this.timeline[0].forEach(function (className) {
        this$1.el.classList.add(className);
    });
};

Animator.prototype.registerListeners = function registerListeners () {
        var this$1 = this;

    if (this.action === 'hover') {
        this.el.addEventListener('mouseenter', function () { return this$1.start(true); });

        if (this.options.rollback) {
            this.el.addEventListener('mouseleave', function () { return this$1.stop(true); });
        }
    }

    else if (this.action === 'click') {
        this.el.addEventListener('mousedown', function () { return this$1.start(true); });
        this.el.addEventListener('touchstart', function () { return this$1.start(true); });

        if (this.options.rollback) {
            this.el.addEventListener('mouseup', function () { return this$1.stop(true); });
            this.el.addEventListener('touchend', function () { return this$1.stop(true); });
        }
    }

    else if (this.action === 'auto') {
        this.start(true);
    }
};

Animator.prototype.destroyListeners = function destroyListeners () {
    this.el.removeEventListener('mouseenter', this.start);
    this.el.removeEventListener('mouseleave', this.stop);
    this.el.removeEventListener('mousedown', this.start);
    this.el.removeEventListener('mouseup', this.stop);
    this.el.removeEventListener('touchstart', this.start);
    this.el.removeEventListener('touchend', this.stop);
};

Animator.prototype.parseProperty = function parseProperty (property) {
    var propertyParts = property.split("-");
    var propertyNameParts = [];
    var value;

    // bg-green-500 is a "single-word" property, while translate-x-3 is not
    if (SINGLE_WORD_PROPERTIES.includes(propertyParts[0]) && propertyParts.length == 3) {
        propertyNameParts = propertyParts.splice(
            0,
            1
        );

        value = propertyParts.join('-');
    }

    // property without a value part (rounded, shadow, border)
    else if (propertyParts.length == 1) {
        propertyNameParts = propertyParts;

        value = null;
    }

    // other properties (w-16, shadow-lg)
    else {
        propertyNameParts = propertyParts.splice(
            0,
            propertyParts.length - 1
        );

        value = propertyParts[propertyParts.length - 1];
    }

    var propertyName = propertyNameParts.join("-");

    // -translate-x-3 converts to a property translate-x with the value of -3
    if (propertyNameParts[0] == "") {
        propertyName = propertyNameParts
            .splice(1)
            .join("-");
        value = -value;
    }

    return [propertyName, value];
};

Animator.prototype.getUsedProperties = function getUsedProperties (keyframes) {
        var this$1 = this;

    return keyframes.map(function (keyframe) {
        return keyframe.split(" ").map(function (property) {
            var ref = this$1.parseProperty(property);
                var propertyName = ref[0];

            return propertyName;
        });
    })
        .flat(1)
        .filter(function (v, i, a) { return a.indexOf(v) === i; });
};

Animator.prototype.buildTimeline = function buildTimeline () {
        var this$1 = this;

    var properties = this.getUsedProperties(this.options[this.action]);
    var timeline = [];

    // build a list of properties with values
    this.options[this.action].forEach(function (keyframe, index) {
        var classList = {};

        keyframe = keyframe.split(" ").map(function (property) {
            var ref = this$1.parseProperty(property);
                var propertyName = ref[0];
                var value = ref[1];
            var result = {};

            result[propertyName] = value;
            return result;
        });

        keyframe = Object.assign.apply(Object, [ {} ].concat( keyframe ));

        properties.forEach(function (propertyName) {
            if (keyframe[propertyName] !== undefined) {
                classList[propertyName] = keyframe[propertyName];
            } else if (index != 0 && propertyName != 'duration') {
                classList[propertyName] = timeline[index - 1][propertyName];
            } else {
                classList[propertyName] = null;
            }
        });

        if (!classList.duration) {
            classList.duration = this$1.options.duration;
        }

        timeline.push(classList);
    });

    // build a sequence of css classes
    timeline.forEach(function (timeframe) {
        var classList = Object.entries(timeframe)
            .map(function (ref) {
                    var propertyName = ref[0];
                    var value = ref[1];

                if (value == null) {
                    return propertyName;
                }
                else if (parseInt(value) === value && value < 0) {
                    return ("-" + propertyName + "-" + (Math.abs(value)));
                } else {
                    return (propertyName + "-" + value);
                }
            });

        if (timeframe.duration) {
            this$1.durations.push(timeframe.duration);
        }
        else {
            this$1.durations.push(this$1.options.duration);
        }

        this$1.timeline.push(classList);
    });
};

Animator.prototype.start = function start (firstInteraction) {
        var this$1 = this;
        if ( firstInteraction === void 0 ) firstInteraction = false;

    if (this.rollbackTimer) {
        clearTimeout(this.rollbackTimer);
    }

    var duration = firstInteraction ? 0 : this.durations[this.index];

    if (this.index == 0 && !firstInteraction && this.options.factor) {
        duration = this.options.duration * (this.options.factor - 1);
    }

    if (firstInteraction) {
        duration += this.options.skip * this.durations[this.index];
        duration += this.options.delay;
    }

    if (!firstInteraction && this.options.stepDelay) {
        duration += this.options.stepDelay;
    }

    this.runTimer = setTimeout(function () { return this$1.run(); }, duration);
};

Animator.prototype.run = function run () {
        var this$1 = this;

    if (this.index == this.timeline.length - 1 && !this.options.repeat) {
        return;
    }

    this.timeline[this.index].forEach(function (className) {
        this$1.el.classList.remove(className);
    });

    if (this.index == this.timeline.length - 1 && this.options.repeat) {
        this.index = 0;
    }
    else {
        this.index++;
    }

    this.timeline[this.index].forEach(function (className) {
        this$1.el.classList.add(className);
    });

    this.start();
};

Animator.prototype.forceRollback = function forceRollback () {
        var this$1 = this;

    return new Promise(function (resolve) {
        while (this$1.index > 0) {
            this$1.timeline[this$1.index].forEach(function (className) {
                this$1.el.classList.remove(className);
            });

            this$1.index--;
        }

        this$1.timeline[0].forEach(function (className) {
            this$1.el.classList.add(className);
        });

        resolve();
    });
};

Animator.prototype.stop = function stop (firstInteraction) {
        var this$1 = this;
        if ( firstInteraction === void 0 ) firstInteraction = false;

    if (this.runTimer) {
        clearTimeout(this.runTimer);
    }

    if (!this.options.rollback) {
        return;
    }

    if (this.options.instantRollback) {
        return this.forceRollback();
    }

    var duration = firstInteraction ? 0 : this.durations[this.index];

    if (firstInteraction) {
        duration += this.options.skip * this.durations[this.index];
        duration += this.options.delay;
    }

    if (!firstInteraction && this.options.stepDelay) {
        duration += this.options.stepDelay;
    }

    this.rollbackTimer = setTimeout(function () { return this$1.rollback(); }, duration);
};

Animator.prototype.rollback = function rollback () {
        var this$1 = this;

    if (this.index == 0) {
        return;
    }

    this.timeline[this.index].forEach(function (className) {
        this$1.el.classList.remove(className);
    });

    this.index--;

    this.timeline[this.index].forEach(function (className) {
        this$1.el.classList.add(className);
    });

    this.stop();
};

var script = {
    props: {
        tag: {
            type: String,
            default: "div",
        },

        options: {
            type: Object,
        },

        value: {
            type: [Number, String, Boolean],
            default: 0,
        },

        trigger: {
            type: Array,
        },

        hover: {
            type: Array,
        },

        auto: {
            type: Array,
        },

        click: {
            type: Array,
        },
    },

    render: function render() {
        return this.$createElement(
            this.tag,
            {
                on: this.$listeners,
            },
            this.$slots.default
        );
    },

    data: function data() {
        return {
            parameters: {
                hover: [],
                click: [],
                trigger: [],
                auto: [],

                instantRollback: false,
                rollback: true,
                repeat: false,
                factor: 0,
                delay: 0,
                stepDelay: 0,
                skip: 0,

                duration: 300,
                ease: "ease-in-out",
            },

            animators: [],
            activated: false,
        };
    },

    methods: {
        setup: function setup() {
            this.parameters = Object.assign({}, this.parameters,
                this.options);

            this.parameters = Object.assign({}, this.parameters,
                {trigger: this.trigger ? this.trigger : this.parameters.trigger,
                hover: this.hover ? this.hover : this.parameters.hover,
                click: this.click ? this.click : this.parameters.click,
                auto: this.auto ? this.auto : this.parameters.auto});

            if (this.parameters.repeat && !this.options.rollback) {
                this.parameters.rollback = false;
            }

            this.addAnimationClasses();
            this.initAnimators();
        },

        initAnimators: function initAnimators() {
            var this$1 = this;

            ["hover", "click", "trigger", "auto"].forEach(function (action) {
                if (this$1.parameters[action].length) {
                    var animator = new Animator(
                        this$1.$el,
                        this$1.parameters,
                        this$1.value,
                        action
                    );

                    animator.setup();

                    this$1.animators.push(animator);
                }
            });
        },

        addAnimationClasses: function addAnimationClasses() {
            this.$el.classList.add("transition-all");
            this.$el.classList.add("transform");
            this.$el.classList.add(this.parameters.ease);
        },
    },

    mounted: function mounted() {
        this.setup();
    },

    beforeDestroy: function beforeDestroy() {
        this.animators.forEach(function (animator) {
            animator.destroyListeners();
        });
    },

    watch: {
        value: function value() {
            var this$1 = this;

            var animator = this.animators.filter(
                function (animator) { return animator.action == "trigger"; }
            )[0];

            if (animator) {
                setTimeout(function () {
                    if (!this$1.activated) {
                        animator.start(true);
                    } else {
                        animator.stop(true);
                    }

                    this$1.activated = !this$1.activated;
                }, this.parameters.delay);
            }
        },
    },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;

/* template */

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

function install(Vue) {
    if (install.installed) { return; }
    install.installed = true;
    Vue.component('Motion', __vue_component__);
}

var plugin = {
    install: install
};

var GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

export default __vue_component__;
export { Animator, install };
